module.exports = __webpack_public_path__ + "static/media/TH_logo.ee76a366.png";